import { createSelector } from 'reselect'
import { isVideoUploading } from '../helpers/interactive_video_creation'

const interactiveVideoData = state => state.interactiveVideoCreation

const videoCreationStatusSelector = createSelector(
	[interactiveVideoData],
	interactiveVideo => {
		const isUploading = isVideoUploading(interactiveVideo)

		return {
			isUploading,
		}
	}
)

export default videoCreationStatusSelector
